import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IStockMovement, IStockMovementsQueryParams } from 'gen/ApiClient';

export const StockMovementsQueryContext = React.createContext<IQueryContext<IQueryResult<IStockMovement>, IStockMovementsQueryParams>>(undefined as any);
